var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 5,
  fill: "none",
  viewBox: "0 0 12 5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#83868A",
  d: "M7.82 4.46C6 4.46 5.16 2.68 3.9 2.68c-.62 0-1.18.46-1.66 1.32L.7 2.84C1.72 1.2 2.86.58 3.94.58c1.86 0 2.68 1.78 3.92 1.78.64 0 1.2-.46 1.68-1.32l1.54 1.16c-1.04 1.64-2.16 2.26-3.26 2.26"
})));
export default SvgIcDash;